import { render, staticRenderFns } from "./FulfillmentPolicy.vue?vue&type=template&id=240581a1&"
import script from "./FulfillmentPolicy.vue?vue&type=script&lang=js&"
export * from "./FulfillmentPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports